import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const ExpandMenuArrow = (properties: iconType) => (
  <SvgIcon
    {...properties}
    viewBox="0 0 13 9"
    style={{ width: '13px', height: '9px', stroke: '#A7B0C0' }}
  >
    <path d="M1.66797 8L5.16797 4.5L1.66797 1" strokeWidth="2" strokeLinecap="round" />
    <path d="M7.5 8L11 4.5L7.5 1" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
);

ExpandMenuArrow.defaultProperties = {
  strokeLinecap: 'round',
  strokeWidth: '2',
  stroke: '#A7B0C0',
};

export default ExpandMenuArrow;
